import classNames from 'classnames';
import { Checkbox } from 'antd';
import { ReactComponent as DeleteIcon } from '@Icons/additional/trash-gradient.svg';
import { ReactComponent as EditIcon } from '@Icons/additional/edit-blue.svg';
import { ReactComponent as RepeatIcon } from '@Icons/additional/repeat.svg';

import styles from './material-item.module.css';

interface MaterialItemProps {
  index: number;
  activityName: string | undefined;
  activityCode: string | number;
  activityId: number | null;
  resourceDescription: string | undefined;
  resourceCode: string | number;
  materialDescription: string | undefined;
  materialCode: string | number;
  materialId: number | null;
  plantCode: string | number;
  plantId: number | null;
  plantName: string | undefined;
  ledgerName: string | undefined;
  ledgerCode: string | number;
  ledgerId: number | null;
  unit: string | number;
  qty: string | number;
  remarks: string;
  repeatItem: boolean;
  checkedItem?: boolean;
  isSelected?: boolean;
  handleDeleteItem: () => void;
  handleEditItem: () => void;
  handleUnselectItem?: () => void;
}

const MaterialItem: React.FC<MaterialItemProps> = ({
  activityCode,
  activityName,
  materialCode,
  materialDescription,
  ledgerName,
  ledgerCode,
  plantName,
  plantCode,
  qty,
  remarks,
  resourceDescription,
  resourceCode,
  unit,
  index,
  handleDeleteItem,
  handleEditItem,
  handleUnselectItem,
  repeatItem = false,
  checkedItem,
  isSelected,
}) => {
  return (
    <div className={classNames(styles.container, repeatItem && styles.active)}>
      <div className={styles.header}>
        {isSelected && (
          <Checkbox
            className={styles.checkbox}
            checked={checkedItem}
            onChange={handleUnselectItem}
          />
        )}
        <div className={styles.caption}>Material No.{index}</div>
        <div className={styles.actions}>
          {repeatItem && <div className={styles.state}>Template</div>}
          <div className={styles.icon} onClick={handleDeleteItem}>
            <DeleteIcon />
          </div>
          <div className={styles.divider} />
          <div className={styles.icon} onClick={handleEditItem}>
            <EditIcon />
          </div>
        </div>
      </div>
      <div className={styles.content}>
        {Boolean(activityCode) && (
          <div className={styles.description}>
            <span>{activityName ? 'Activity' : 'Activity Code'}</span>
            <div>
              {repeatItem && (
                <span className={styles.repeatIcon}>
                  <RepeatIcon />
                </span>
              )}
              <span>
                {activityName
                  ? `${activityName} (${activityCode})`
                  : activityCode}
              </span>
            </div>
          </div>
        )}
        {Boolean(resourceCode) && (
          <div className={styles.description}>
            <span>{resourceDescription ? 'Resource' : 'Resource Code'}</span>
            <span>{resourceDescription || resourceCode}</span>
          </div>
        )}
        {Boolean(materialCode) && (
          <div className={styles.description}>
            <span>{materialDescription ? 'Material' : 'Material Code'}</span>
            <span>
              {materialDescription
                ? `${materialDescription} (${materialCode})`
                : materialCode}
            </span>
          </div>
        )}
        {Boolean(plantCode) && (
          <div className={styles.description}>
            <span>{plantName ? 'Plant' : 'Plant Code'}</span>
            <span>{plantName ? `${plantName} (${plantCode})` : plantCode}</span>
          </div>
        )}
        {Boolean(ledgerCode) && (
          <div className={styles.description}>
            <span>{ledgerName ? 'Ledger' : 'Ledger Code'}</span>
            <span>
              {ledgerName ? `${ledgerName} (${ledgerCode})` : ledgerCode}
            </span>
          </div>
        )}
        <div className={styles.description}>
          <span>Unit</span>
          <span>{unit}</span>
        </div>
        <div className={styles.description}>
          <span>Qty.</span>
          <span>{qty}</span>
        </div>
        <div className={styles.description}>
          <span>Remarks</span>
          <span>{remarks}</span>
        </div>
      </div>
    </div>
  );
};

export default MaterialItem;
